/* eslint-disable no-console */
import { addToEpiCart, removeFromEpiCart } from './utils/cart-utils';
import { addToOrderLine, removeOrderLine } from './utils/sst-utils';
import { gaAddToCart } from './utils/ga-ecommerce-utils';
import { getMiniCartHtml } from './modules/mini-cart';
import { validate } from './utils/form-validation-utils';
import SiteToaster from './modules/site-toaster';

import SitePopup from './modules/site-popup';

export default class Accessories {
  constructor() {
    const that = this;
    this.getDetailModalUrl = 'GetAccessoryDetailModal';
    this.getSwapAccessoryUrl = 'SwapAccessory';
    this.modalId = 'accessory-detail-modal';
    this.modelListSelector = document.getElementById('Model');
    this.sizeListSelector = document.getElementById('Size');
    this.mountListSelector = document.getElementById('Mount');
    this.maxAccessoriesForInitialDisplay = 0;
    this.accessoryGrid = document.getElementById('accessoryGrid');
    this.hiddenSelector = 'hidden';
    this.toaster = null;
    this.addStatus = 'add';
    this.removeStatus = 'remove';
    // Add events to model selector, if exsits in this state
    if (this.modelListSelector !== null) {
      this.modelListSelector.addEventListener('change', (event) => {
        that.getAvailableSizesForSelectedModel(event);
        that.getAvailableMountTypesForSelectedModel(event);
      });
    }
    // Add events to accessory search form, if exsits in this state
    this.form = document.querySelector('.site-form');
    if (this.form !== null) {
      this.submitBtn = this.form.querySelector('.submit-btn');
      this.submitBtn.addEventListener('click', (event) => {
        event.preventDefault();
        that.submitBtn.classList.add('updating');
        that.submitBtn.setAttribute('disabled', 'disabled');
        const isValid = validate(this.form);
        if (isValid) {
          that.getAccessoriesForAwning();
        }
      });
    }
    // Add events to "Show More/Less" buttons, if exists in this state
    this.showMoreBtn = document.querySelector('.show-more-btn');
    if (this.showMoreBtn !== null) {
      this.showMoreBtn.addEventListener('click', () => {
        this.showAdditionalAccessories();
      });
    }
    this.showLessBtn = document.querySelector('.show-less-btn');
    if (this.showLessBtn !== null) {
      this.showLessBtn.addEventListener('click', () => {
        this.hideAdditionalAccessories();
      });
    }
    // Reset button
    document.addEventListener('click', (event) => {
      if (event.target.closest('.reset-results-btn')) {
        this.reset();
      }
    });
    // Grid/Accessory events
    document.addEventListener('click', (event) => {
      const btn = event.target;
      const code = btn.getAttribute('data-product-code');
      const epiCode = btn.getAttribute('data-episerver-product-code');
      // Check for options form element
      // Add validation for Install Fee and Roof Brackets (FSR)
      const optionsId = btn.getAttribute('data-options-id');
      const optionsElmt = document.getElementById(optionsId);
      // Add to cart
      if (btn.classList.contains('add-to-cart-btn')) {
        // Check to see if accessory exists in catalog
        if (epiCode !== '') {
          addToOrderLine(code)
            .then((data) => {
              // Update btn state
              if (data.Qty > 0 && btn.classList.contains('co-btn')) {
                this.updateCartBtnLabel(btn, this.removeStatus);
              } else {
                this.updateCartBtnLabel(btn, this.addStatus);
              }
              // Update quantity state
              this.updateCartQty(btn, data.Qty);
              addToEpiCart(code);
            })
            .then(() => {
              getMiniCartHtml();
              this.displayToaster('Item has been added to your cart.');
            })
            .catch(console.error);
        } else {
          let unitPrice = '';
          let itemQty = '1';
          if (optionsElmt !== null) {
            const optionName = optionsElmt.getAttribute('data-option-name');
            const { alert } = window;
            if (optionName === 'currency') {
              unitPrice = optionsElmt.value;
              const isPrice = parseFloat(unitPrice) > 0;
              // Validation
              if (!isPrice) {
                alert('Please enter a valid price before adding to cart.');
                return;
              }
            } else if (optionName === 'quantity') {
              itemQty = optionsElmt.value;
              // Validation
              if (itemQty === '') {
                alert('Please select a value before adding to cart.');
                return;
              }
            }
          }
          addToOrderLine(code, '', unitPrice, itemQty)
            .then((data) => {
              // Update btn state
              if (data.Qty > 0 && btn.classList.contains('co-btn')) {
                this.updateCartBtnLabel(btn, this.removeStatus);
              } else {
                this.updateCartBtnLabel(btn, this.addStatus);
              }
              // Update quantity state
              this.updateCartQty(btn, data.Qty);
              // Disable options form element
              if (optionsElmt !== null) {
                optionsElmt.setAttribute('disabled', 'disabled');
              }
              this.displayToaster('Item has been added to your cart.');
            })
            .catch(console.error);
        }
        return;
      }
      // Remove from cart
      if (btn.classList.contains('remove-from-cart-btn')) {
        removeOrderLine(code)
          .then((data) => {
            // Update btn state
            this.updateCartBtnLabel(btn, this.addStatus);
            this.updateCartQty(btn, data.Qty);
            removeFromEpiCart(code);
          })
          .then(() => {
            getMiniCartHtml();
            // Enable options form element
            if (optionsElmt !== null) {
              optionsElmt.removeAttribute('disabled');
            }
            this.displayToaster('Item has been removed from your cart.');
          })
          .catch(console.error);
        return;
      }
      // Swap Accessory
      if (btn.classList.contains('swap-accessory-btn')) {
        const itemNoFrom = btn.getAttribute('data-itemno-from');
        const itemNoTo = btn.getAttribute('data-itemno');
        this.swapAccessory(itemNoFrom)
          .then(gaAddToCart(itemNoTo))
          .then(() => {
            getMiniCartHtml();
            this.displayToaster('Item has been added to your cart.');
            // Display hood added to order message
            const orderHoodMsg = document.getElementById('orderHoodMsg');
            const hoodAddedToOrderMsg = document.getElementById('hoodAddedToOrderMsg');
            orderHoodMsg.classList.add('hidden');
            hoodAddedToOrderMsg.classList.remove('hidden');
          });
        return;
      }
      // Launch detail modal
      const modalBtn = btn.closest('.product-detail-modal-btn');
      if (modalBtn != null) {
        event.preventDefault();
        this.removeExistingDetailModal();
        this.getAccessoryDetailModal(code)
          .then((data) => {
            if (data !== '~error~') {
              this.initModal(data);
            }
          })
          .catch(console.error);
      }
    });
  }

  swapAccessory(itemNoFrom) {
    const url = `${this.getSwapAccessoryUrl}?itemNoFrom=${itemNoFrom}`;
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: 'POST',
      })
        .then((response) => {
          if (response.ok) {
            response.text().then(resolve);
          } else {
            response.text().then(reject);
          }
        })
        .catch(console.error);
    });
  }

  updateCartBtnLabel(btn, status) {
    if (status === this.addStatus) {
      btn.textContent = 'Add to Cart';
      btn.classList.add('add-to-cart-btn');
      btn.classList.remove('remove-from-cart-btn');
    } else if (status === this.removeStatus) {
      btn.textContent = 'Remove from Cart';
      btn.classList.remove('add-to-cart-btn');
      btn.classList.add('remove-from-cart-btn');
    }
  }

  updateCartQty(btn, qty) {
    const qtyWrapper = btn.parentNode.querySelector('.cart-qty');
    const qtyIpt = btn.parentNode.querySelector('.form-control-qty');
    if (qty === 0) {
      qtyWrapper.classList.add(this.hiddenSelector);
    } else {
      qtyWrapper.classList.remove(this.hiddenSelector);
    }
    qtyIpt.value = qty;
  }

  displayToaster(msg) {
    if (this.toaster) {
      this.toaster.remove();
    }
    this.toaster = new SiteToaster({
      id: 'status-toaster',
      message: `<strong>${msg}</strong>`,
    });
    this.toaster.open();
    setTimeout(() => {
      if (this.toaster) {
        this.toaster.close();
      }
    }, 3000);
    setTimeout(() => {
      if (this.toaster) {
        this.toaster.remove();
      }
    }, 3300);
  }

  setAccessoryGridFocus() {
    // Set focus to first button in grid
    const accessoryItems = this.accessoryGrid.querySelectorAll('.accessory-card button');
    if (accessoryItems.length > 0) {
      accessoryItems[0].focus();
    }
  }

  showAdditionalAccessories() {
    const accessoryItems = this.accessoryGrid.querySelectorAll('.col');
    const accessoriesShown = this.accessoryGrid.querySelectorAll('.col:not(.d-none)').length;
    this.maxAccessoriesForInitialDisplay = accessoriesShown;
    [].map.call(accessoryItems, (item) => {
      item.classList.remove('d-none');
      item.classList.add('d-flex');
    });
    this.showMoreBtn.classList.add(this.hiddenSelector);
    this.showLessBtn.classList.remove(this.hiddenSelector);
    this.setAccessoryGridFocus();
  }

  hideAdditionalAccessories() {
    const hideAfter = this.maxAccessoriesForInitialDisplay;
    const accessoryItems = this.accessoryGrid.querySelectorAll(`.col:nth-child(n + ${hideAfter})`);
    [].map.call(accessoryItems, (item) => {
      item.classList.remove('d-flex');
      item.classList.add('d-none');
    });
    this.showMoreBtn.classList.remove(this.hiddenSelector);
    this.showLessBtn.classList.add(this.hiddenSelector);
    this.setAccessoryGridFocus();
  }

  reset() {
    // Reset selects
    this.modelListSelector.value = '';
    this.sizeListSelector.value = '';
    this.mountListSelector.value = '';
    // Disable selects
    this.sizeListSelector.classList.add('disabled');
    this.sizeListSelector.setAttribute('disabled', 'disabled');
    this.mountListSelector.classList.add('disabled');
    this.mountListSelector.setAttribute('disabled', 'disabled');
    // Remove additional options from sizes sand mount
    const sizeOptions = this.sizeListSelector.querySelectorAll('option:nth-child(n + 2)');
    [].map.call(sizeOptions, (option) => {
      option.remove();
    });
    const mountOptions = this.mountListSelector.querySelectorAll('option:nth-child(n + 2)');
    [].map.call(mountOptions, (option) => {
      option.remove();
    });
    // Remove results
    this.accessoryGrid.innerHTML = '';
  }

  getAccessoryDetailModal(code) {
    const url = `${this.getDetailModalUrl}?code=${code}`;
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: 'POST',
      })
        .then((response) => {
          if (response.ok) {
            response.text().then(resolve);
          } else {
            response.text().then(reject);
          }
        })
        .catch(console.error);
    });
  }

  removeExistingDetailModal() {
    const detailModal = document.getElementById(this.modalId);
    if (detailModal != null) {
      detailModal.remove();
    }
  }

  initModal(modalHtml) {
    // Append html to the end of the DOM
    const body = document.querySelector('body');
    const div = document.createElement('div');
    div.innerHTML = modalHtml.trim();
    body.appendChild(div.firstChild);
    // Define div references
    const modal = new SitePopup({
      id: this.modalId,
    });
    modal.updateHeight();
    modal.open();
  }

  getAvailableSizesForSelectedModel(event) {
    const code = event.target.value;
    const request = new XMLHttpRequest();
    request.open('POST', `GetModelSizes/?code=${code}`);
    request.onload = () => {
      if (request.status >= 200 && request.status < 400) {
        this.sizeListSelector.innerHTML = request.responseText;
        this.sizeListSelector.removeAttribute('disabled');
        this.sizeListSelector.classList.remove('disabled');
      }
    };
    request.send();
  }

  getAvailableMountTypesForSelectedModel(event) {
    const code = event.target.value;
    const request = new XMLHttpRequest();
    request.open('POST', `GetModelMountTypes/?code=${code}`);
    request.onload = () => {
      if (request.status >= 200 && request.status < 400) {
        this.mountListSelector.innerHTML = request.responseText;
        if (this.mountListSelector.querySelectorAll('option').length > 1) {
          this.mountListSelector.removeAttribute('disabled');
          this.mountListSelector.classList.remove('disabled');
        } else {
          this.mountListSelector.setAttribute('disabled', 'disabled');
          this.mountListSelector.classList.add('disabled');
        }
      }
    };
    request.send();
  }

  getAccessoriesForAwning() {
    const { submitBtn } = this;
    const model = this.modelListSelector.value;
    const size = this.sizeListSelector.value;
    const mount = this.mountListSelector.value;
    const request = new XMLHttpRequest();
    request.open('POST', `GetAccessoriesForAwning/?model=${model}&size=${size}&mount=${mount}`);
    request.onload = () => {
      submitBtn.classList.remove('updating');
      submitBtn.removeAttribute('disabled');
      if (request.status >= 200 && request.status < 400) {
        const wrapper = document.getElementById('accessoryGrid');
        wrapper.innerHTML = request.responseText;
      }
    };
    request.send();
  }
}
window.Accessories = Accessories;
/* eslint-enable no-console */
